import styles from './Photo.module.css';

export const Photo = ({ message, rotateSign, maxWidth = '75rem' }) => {
  if (!message) return null;
  return (
    <div
      style={{
        '--angle': `${rotateSign}5deg`,
        transform: `rotate(${rotateSign}5deg)`,
      }}
      className={styles.photo}
      key={message.id}
    >
      <figure className={styles.imageFigure}>
        <img
          src={message?.attachments[0]?.url}
          alt={'attach'}
          style={{ maxWidth }}
        />
        {message?.content && (
          <figcaption className={styles.text}>
            <div>{message?.content}</div>
          </figcaption>
        )}
      </figure>
    </div>
  );
};
